var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('StreamProduct',{attrs:{"product":_vm.product}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }